import React, { useState } from 'react'
import { useMutation } from '@redwoodjs/web'
import { AltiumLogo } from 'src/components/CadLogo'
import Button from '../Button'

export const INITIATE_AUTH = gql`
  mutation InitiateNexarAuth($input: InitiateNexarAuthInput!) {
    initiateNexarAuth(input: $input) {
      url
    }
  }
`

interface AltiumLoginProps {
  className?: string
  buttonText?: string
}

const AltiumLogin: React.FC<AltiumLoginProps> = ({
  className = '',
  buttonText = 'Login to connect'
}) => {
  const [loading, setLoading] = useState(false)

  const [initiateAuth] = useMutation(INITIATE_AUTH)

  const handleAuth = async () => {
    try {
      setLoading(true)
      const { data } = await initiateAuth({
        variables: {
          input: {
            whenDoneRedirectUrl: window.location.href
          }
        }
      })

      if (data) {
        window.location.href = data.initiateNexarAuth.url
      }
    } catch (error) {
      console.error('Auth initiation failed:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={`flex flex-col items-end gap-4 ${className}`}>
      <AltiumLogo className="w-32" />
      <Button
        onClick={handleAuth}
        disabled={loading}
      >
        {buttonText}
      </Button>
    </div>
  )
}

export default AltiumLogin